import React from "react";
import "../SignIn/SignIn.css";
import { Image, Container, Col, Row, Button } from "react-bootstrap";
import Logo from "../../assets/communityXlogo.svg";
import Form from "react-bootstrap/Form";
import { Link, useLocation, useNavigate } from "react-router-dom";
import forgot from "../../assets/forgot.png";
import { MdArrowBack } from "react-icons/md";
import { useState } from "react";
import {
  ConfirmPasswordCheck,
  CreatePasswordCheck,
} from "../../ConditionChecks/ConditionChecks";
import { CreatePswdApi } from "../../Utils/Api/CreatePswdApi";
import ErrorLabel from "../../Components/ErrorLabel/ErrorLabel";
import Loader from "../../Components/Loader/Loader";
import { FaEyeSlash, FaEye } from "react-icons/fa";
import { toast } from "react-toastify";
import { ServerError } from "../../Utils/GlobalVariables/ToastifierVariables";

const CreateNewPassword = () => {
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [errDisplayNewPswd, setErrDisplayNewPswd] = useState("");
  const [errDisplayConfirmPswd, setErrorDisplayConfirmPswd] = useState("");
  const [apiErrDisplay, setApiErrDisplay] = useState("");
  const [loading, setLoading] = useState(false);
  const [oldPassword, setOldPassword] = useState("");
  const [visibleOldPassword, setVisibleOldPassword] = useState(true);
  const [visibleOldPassword2, setVisibleOldPassword2] = useState(true);

  const onOldPassword = (e) => {
    let oldpswd = e.target.value;
    setOldPassword(oldpswd);
  };
  const OldPasswordVisibleHandler = () => {
    setVisibleOldPassword(true);
  };
  const OldPasswordNotVisibleHandler = () => {
    setVisibleOldPassword(false);
  };
  const OldPasswordVisibleHandler2 = () => {
    setVisibleOldPassword2(true);
  };
  const OldPasswordNotVisibleHandler2 = () => {
    setVisibleOldPassword2(false);
  };

  const location = useLocation();
  const Api_Token = location.state.token;

  const navigate = useNavigate();

  const onNewPswd = (e) => {
    let NewPswd = e.target.value;
    setNewPassword(NewPswd);
    setErrDisplayNewPswd("");
  };

  const onConfirmPswd = (e) => {
    let ConfirmPswd = e.target.value;
    setConfirmPassword(ConfirmPswd);
    setErrorDisplayConfirmPswd("");
  };

  const SaveHandler = (e) => {
    e.preventDefault();
    const NewPasswordValidation = CreatePasswordCheck(newPassword);
    const ConfirmPasswordValidation = ConfirmPasswordCheck(
      newPassword,
      confirmPassword
    );

    if (NewPasswordValidation.input === "empty") {
      setErrDisplayNewPswd(NewPasswordValidation.err_display);
    } else if (NewPasswordValidation.input === "lesscharacters") {
      setErrDisplayNewPswd(NewPasswordValidation.err_display);
    } else if (NewPasswordValidation.input === "invalid") {
      setErrDisplayNewPswd(NewPasswordValidation.err_display);
    }

    if (ConfirmPasswordValidation.input === "empty") {
      setErrorDisplayConfirmPswd(ConfirmPasswordValidation.err_display);
    } else if (ConfirmPasswordValidation.input === "deosnotmatch") {
      setErrorDisplayConfirmPswd(ConfirmPasswordValidation.err_display);
    }

    if (
      NewPasswordValidation.validition &&
      ConfirmPasswordValidation.validition === true
    ) {
      let NewPswd = {
        token: Api_Token,
        password: confirmPassword.trim(),
      };
      CreateNewPasswordHandler(NewPswd);
    }
  };

  const CreateNewPasswordHandler = async (data) => {
    setLoading(true);
    const NewPswdResponse = await CreatePswdApi(data, () => {
      navigate("/");
    });
    if (NewPswdResponse === false) {
      toast.error(ServerError, {
        position: "top-center",
        width: "500px",
        autoClose: 6000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
      navigate("/forgotpassword");
      setLoading(false);
    } else {
      if (NewPswdResponse.success === true) {
        toast.success(NewPswdResponse.p_responseMessage, {
          position: "top-center",
          width: "500px",
          autoClose: 6000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
        navigate("/");
        setLoading(false);
      } else {
        toast.error(NewPswdResponse.p_responseMessage, {
          position: "top-center",
          width: "500px",
          autoClose: 6000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
        setLoading(false);
      }
    }
  };

  return (
    <>
      {loading ? <Loader /> : ""}
      <div className="main">
        <Container>
          <Row className="justify-content-md-center py-3 mobile-main">
            <Col md="6" className="page-content-left text-center hide-mobile">
              <Image
                loading="lazy"
                src={forgot}
                className="my-5 py-5 imgwidth-100"
              ></Image>
            </Col>
            <Col md="6" className="page-content-right">
              <div className="text-center mt-5 mb-2">
                <Image loading="lazy" src={Logo} className="logo_Image"></Image>
                <div
                  style={
                    apiErrDisplay === "Your password has successfully changed"
                      ? { color: "green" }
                      : { color: "red" }
                  }
                  className="p-4"
                >
                  {apiErrDisplay}
                </div>
                <p className="sign-second mt-1 pt-1 pb-2">
                  Create new password
                </p>
              </div>
              <Row>
                <div className="signemail pt-0 pb-3">
                  <Form onSubmit={SaveHandler} className="formmain signin-row">
                    <Form.Group
                      className="mb-3"
                      controlId="formBasicPassword"
                      style={{ position: "relative" }}
                    >
                      <Form.Label className="form-label-custom">
                        New Password <span className="star-required">*</span>
                      </Form.Label>
                      <div className="position-relative">
                        <Form.Control
                          onChange={onNewPswd}
                          type={visibleOldPassword === true ? "password" : ""}
                          placeholder="New Password"
                          className="custom-formcontrol"
                        />
                        {visibleOldPassword === true ? (
                          <Button
                            variant="outline-secondary"
                            className="edit-mainn px-2 newpswd"
                            onClick={OldPasswordNotVisibleHandler}
                          >
                            <FaEyeSlash className="eyeIcon" />
                          </Button>
                        ) : (
                          <Button
                            variant="outline-secondary"
                            className="edit-mainn px-2"
                            onClick={OldPasswordVisibleHandler}
                          >
                            <FaEye className="eyeIcon" />
                          </Button>
                        )}
                      </div>
                      <ErrorLabel ErrorDisplay={errDisplayNewPswd} />
                    </Form.Group>
                    <Form.Group
                      className="mb-3"
                      controlId="formBasicPassword"
                      style={{ position: "relative" }}
                    >
                      <Form.Label className="form-label-custom">
                        Confirm Password{" "}
                        <span className="star-required">*</span>
                      </Form.Label>
                      <div className="position-relative">
                        <Form.Control
                          onChange={onConfirmPswd}
                          type={visibleOldPassword2 === true ? "password" : ""}
                          placeholder="Confirm Password"
                          className="custom-formcontrol"
                        />
                        {visibleOldPassword2 === true ? (
                          <Button
                            variant="outline-secondary"
                            className="edit-mainn px-2 confirmpswd"
                            onClick={OldPasswordNotVisibleHandler2}
                          >
                            <FaEyeSlash className="eyeIcon" />
                          </Button>
                        ) : (
                          <Button
                            variant="outline-secondary"
                            className="edit-mainn px-2"
                            onClick={OldPasswordVisibleHandler2}
                          >
                            <FaEye className="eyeIcon" />
                          </Button>
                        )}
                      </div>
                      <ErrorLabel ErrorDisplay={errDisplayConfirmPswd} />
                    </Form.Group>
                    <div className="password_Label_Div">
                      <span className="password_Label">
                        (Create a strong password with a mix of upper case
                        letters, alphanumeric and symbols containing at least 8
                        characters.)
                      </span>
                    </div>

                    <div className="text-center">
                      <Button
                        variant="primary"
                        type="submit"
                        className="green-btn mt-3"
                      >
                        Save
                      </Button>
                    </div>
                  </Form>
                </div>
                <Link to={"/"}>
                  <p className="text-center back-btn">
                    <MdArrowBack />
                    Back
                  </p>
                </Link>
              </Row>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default CreateNewPassword;
